import { Injectable } from '@angular/core';
import { RemoteConfigService } from '../views/components/ui-components/src/bn-marketing-carousel/firebase-remote-config.service';

export interface FeatureFlags {
  showOnboarding: boolean;
  showTermDeposit: boolean;
  greenPointsMinimumAmount: number;
  showTransactionClaim: boolean;
  showCashAdvance: boolean;
  showBankingCertifications: boolean;
  enablePushNotifications: boolean;
  enableACHTransfer: boolean;
}

const DEFAULT_FLAGS: FeatureFlags = {
  showOnboarding: true,
  showTermDeposit: true,
  greenPointsMinimumAmount: 3000,
  showTransactionClaim: true,
  showCashAdvance: true,
  showBankingCertifications: true,
  enablePushNotifications: true,
  enableACHTransfer: true,
};

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  private flags: FeatureFlags | null = null;
  private loadPromise: Promise<FeatureFlags> | null = null;

  constructor(private remoteConfigService: RemoteConfigService) {}

  getFlags(): Promise<FeatureFlags> {
    if (this.flags) return Promise.resolve(this.flags);
    if (!this.loadPromise) this.loadPromise = this.fetchFlags();
    return this.loadPromise;
  }

  private async fetchFlags(): Promise<FeatureFlags> {
    try {
      const key = `web_flags_${this.remoteConfigService.envName}`;
      const response = await this.remoteConfigService.fetchAndGetValue(key);
      this.flags = { ...DEFAULT_FLAGS, ...JSON.parse(response) };
    } catch (e) {
      console.log(e);
      this.flags = DEFAULT_FLAGS;
    }
    return this.flags;
  }
}
